import React, { useState } from "react";
import MobileNavigationBar from "../components/mobileNavbar";
import MobileFooter from "../components/mobileFooter";
import { Container, Accordion } from "react-bootstrap";

const FAQMobile = () => {
  const [activeKey, setActiveKey] = useState(null);

  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  return (
    <div style={{ backgroundColor: '#f4f4f4' }}>
      <MobileNavigationBar />
      <Container className="my-3">
        <h2>Frequently Asked Questions</h2>
        <div className="mb-5">
          <h4 className="fw-bold mt-4 mb-2">About GAMRC</h4>
          <Accordion activeKey={activeKey} onSelect={handleToggle} flush>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                Is Greater Austin Muslim Relief Committee (GAMRC) an organization with an EIN number?
              </Accordion.Header>
              <Accordion.Body>
                No, we are not an organization, we are a unified committee of all the local Austin masajid.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>Can I write a check to GAMRC?</Accordion.Header>
              <Accordion.Body>
                No, we don’t have a separate bank account. Please write the check to one of the mosques listed above. For more information, click <a href="/PayZakatHere">here</a>.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>Can I volunteer with GAMRC?</Accordion.Header>
              <Accordion.Body>
                Yes. Contact us for more details.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          <h4 className="fw-bold mt-4 mb-2">Zakat Questions</h4>
          <Accordion activeKey={activeKey} onSelect={handleToggle} flush>
            <Accordion.Item eventKey="4">
              <Accordion.Header>Where can I pay my zakat ul Maal?</Accordion.Header>
              <Accordion.Body>
                In any of the mosques that are part of GAMRC: Nueces Mosque, ICGA, ICBC, ICRR, ICLT, GIC, ICHC, ICP, Masjid Noor, Al-Huda, ICQC. Or click <a href="/PayZakatHere">here</a>.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5">
              <Accordion.Header>Is my zakat distributed locally?</Accordion.Header>
              <Accordion.Body>
                Yes. Our focus is to help those in Austin and the surrounding cities.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="6">
              <Accordion.Header>Is my zakat used for operations or buildings?</Accordion.Header>
              <Accordion.Body>
                Absolutely NOT. Zakat is spent on the 8 categories in the Quran, all of which relate to people.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="7">
              <Accordion.Header>Is my zakat used for educational scholarships or support?</Accordion.Header>
              <Accordion.Body>
                With permission from the recipient, zakat can go toward Islamic school, certifications, or job-skills classes.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="8">
              <Accordion.Header>Do I only give Zakat in Ramadan?</Accordion.Header>
              <Accordion.Body>
                No, Zakat doesn’t have to be given only in Ramadan. Zakat is a fardh (obligatory) act of worship and should be given once a year based on your Nisab date.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          <h4 className="fw-bold mt-4 mb-2">Zakat Distribution & Eligibility</h4>
          <Accordion activeKey={activeKey} onSelect={handleToggle} flush>
            <Accordion.Item eventKey="9">
              <Accordion.Header>Where do you help Muslims vs non-Muslims from?</Accordion.Header>
              <Accordion.Body>
                Muslims are helped from zakat. Non-Muslims are helped from voluntary charity (Sadaqah).
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="10">
              <Accordion.Header>How do you determine eligibility of zakat recipients?</Accordion.Header>
              <Accordion.Body>
                <a href="/howitworks">Click here</a> to read about our thorough process of determining eligibility.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="11">
              <Accordion.Header>How long can someone receive zakat?</Accordion.Header>
              <Accordion.Body>
                Case by case. Factors like language skills and job options vary. Everyone is regularly evaluated.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="12">
              <Accordion.Header>Who receives and how is zakat ul Fitr distributed?</Accordion.Header>
              <Accordion.Body>
                Those eligible for zakat ul Maal also receive zakat ul Fitr.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          <h4 className="fw-bold mt-4 mb-2">Donations & Qurbani</h4>
          <Accordion activeKey={activeKey} onSelect={handleToggle} flush>
            <Accordion.Item eventKey="13">
              <Accordion.Header>Does GAMRC collect and distribute Qurbani meat?</Accordion.Header>
              <Accordion.Body>
                <a href="/eid-al-adha">Click here</a> for more details on Eid Al Adha.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="14">
              <Accordion.Header>Do I get a tax receipt for donations?</Accordion.Header>
              <Accordion.Body>
                Yes, from the mosque finance team. For in-kind donations, items must be in excellent shape.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="15">
              <Accordion.Header>Can I donate a vehicle and get a tax receipt?</Accordion.Header>
              <Accordion.Body>
                Yes, if in excellent working condition. For donations over $500, your SSN is required for the tax form.
                When filling out the contact us form please provide: car make, model, year, VIN and mileage.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </Container>
      <MobileFooter />
    </div>
  );
};

export default FAQMobile;
